import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ACHIEVEMENT_RECORDS,
  ACHIEVEMENT_RECORDS_ALL,
  ACHIEVEMENT_RECORDS_CHANGE_STATUS,
  ACHIEVEMENT_RECORDS_CREATE,
  ACHIEVEMENT_RECORDS_LIST,
  ACHIEVEMENT_RECORDS_STUDENT,
  ACHIEVEMENT_RECORDS_TYPES,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const achievementsRecordsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const achievementRecordsSelector = createSelector(achievementsRecordsSelector, data => data[ACHIEVEMENT_RECORDS])

export const achievementRecordsListSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_LIST]
)

export const achievementRecordsAllSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_ALL]
)

export const achievementRecordsStudentSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_STUDENT]
)

export const achievementRecordsTypesSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_TYPES]
)

export const achievementRecordsStatusChangeSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_CHANGE_STATUS]
)

export const achievementRecordsCreateSelector = createSelector(
  achievementsRecordsSelector,
  data => data[ACHIEVEMENT_RECORDS_CREATE]
)
